export default {
    'name': 'square',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M15 9H9V15H15V9Z\' fill=\'#026958\'/>'
}
